import {
  FAIRLEAD_LABEL,
  MOORING_POINT_LABEL,
  PEDESTAL_LABEL,
  TAULINE_LABEL,
  WINCH_LABEL
} from '@/constants/shipConstants'
import type { TooltipItem } from 'chart.js'
import type { TickContext } from './type/chartTypes'

const getTooltipLabel = (prefix = '', item: any) => {
  let label = ''
  if ('name' in item) {
    label = item.name
  } else if ('number' in item) {
    label = prefix + item.number
  } else if ('index' in item) {
    label = prefix + (item.index + 1)
  }
  if ('z' in item) {
    return label + ` (x: ${item.x.toFixed(2)}, y: ${item.y.toFixed(2)}, z: ${item.z.toFixed(2)})`
  }
  return label + ` (x: ${item.x.toFixed(2)}, y: ${item.y.toFixed(2)})`
}

const label = (context: TooltipItem<any>) => {
  const label = context.dataset.label || ''
  const item = context.dataset.data[context.dataIndex]
  if (!label) {
    return null
  }

  if (label.includes(MOORING_POINT_LABEL)) {
    return getTooltipLabel(item.name, item)
  } else if (label.includes(FAIRLEAD_LABEL)) {
    return getTooltipLabel('F', item)
  } else if (label.includes(WINCH_LABEL)) {
    return getTooltipLabel('W', item)
  } else if (label.includes(PEDESTAL_LABEL)) {
    return getTooltipLabel('P', item)
  }
  return
}

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    tooltip: {
      callbacks: {
        label: label
      },
      filter: function (context: TooltipItem<any>) {
        return context.dataset.label !== 'Ship Contour' && context.dataset.label !== TAULINE_LABEL
      }
    },
    datalabels: {
      labels: {
        title: {
          color: null
        }
      }
    },
    zoom: {
      pan: { enabled: true, modifierKey: null },
      zoom: {
        wheel: {
          enabled: true,
          modifierKey: 'ctrl'
        },
        pinch: {
          enabled: true
        },
        mode: 'xy'
      }
    },
    legend: {}
  }
}
export const shipChartLegendConfig = {
  position: 'top',
  align: 'center',
  display: true,
  labels: {
    usePointStyle: true
  }
}

export const mooringChartLegendConfig = {
  onClick: null,

  labels: {
    filter: function (l: any) {
      if (l.text) {
        return l.text.includes('Capacity')
      } else {
        return null
      }
    }
  },
  display: true,
  position: 'chartArea',
  align: 'end'
}

export const mooringChartConfig = {
  ...options,
  plugins: {
    ...options.plugins,
    legend: mooringChartLegendConfig
  }
}

export const mooringChartScaleConfig = {
  x: {
    ticks: {
      display: true,
      z: 1,
      showLabelBackdrop: true,
      minRotation: 0,
      maxRotation: 0,
      crossAlign: 'near',
      color: function (context: TickContext) {
        if (context.tick.value === 0) {
          return 'rgb(0,0,0)'
        } else {
          return 'rgba(0,0,0,0.75)'
        }
      },
      callback: function (value: number) {
        if (value === 0) {
          return [value, 'Spotting line']
        } else {
          return value.toFixed(0)
        }
      }
    },
    grid: {
      color: function (context: TickContext) {
        if (context.tick.value === 0) {
          return 'rgba(0,0,0,0.25)'
        } else {
          return 'rgba(0,0,0,0.1)'
        }
      },
      lineWidth: function (context: TickContext) {
        if (context.tick.value === 0) {
          return 2
        } else {
          return 1
        }
      }
    }
  },
  y: {
    position: 'right',
    ticks: {
      display: true,
      mirror: true,
      padding: 30,
      showLabelBackdrop: true,
      z: 1,
      color: function (context: TickContext) {
        if (context.tick.value === 0) {
          return 'rgb(0,0,0)'
        } else {
          return 'rgba(0,0,0,0.75)'
        }
      },
      callback: function (value: number) {
        if (value === 0) {
          return 'Berthing line         ' + value
        } else {
          return value.toFixed(0)
        }
      }
    },
    grid: {
      color: function (context: TickContext) {
        if (context.tick.value === 0) {
          return 'rgba(0,0,0,0.25)'
        } else {
          return 'rgba(0,0,0,0.1)'
        }
      },
      lineWidth: function (context: TickContext) {
        if (context.tick.value === 0) {
          return 2
        } else {
          return 1
        }
      }
    }
  }
}
